/* globals angular */
angular
  .module('mandaeApp')
  .factory('FinanceiroResource', function ($resource, URL_FINANCEIRO) {
    'use strict';
    return $resource(URL_FINANCEIRO, {}, {
      getTotalFaturas: {
        method: 'GET',
        url: URL_FINANCEIRO + '/v2/faturas'
      }
    });
  });
